import Detail from './Detail'
import HistoryList from './HistoryList'
import MandatItem from './MandatItem'
import { typeBienOptions as bienOptions, typeMandatOptions as mandatOptions} from './options'

export const typeBienOptions = bienOptions
export const typeMandatOptions = mandatOptions

const Mandat = {
  Detail,
  HistoryList,
  MandatItem,
  typeBienOptions,
  typeMandatOptions
}

export default Mandat